import { updateItemInCollection } from "directus/src/operations";

export async function updateMeeting({ meetingId, item }) {
  try {
    const query = {
      fields: [
        "id",
        "title",
        "starts_at",
        "ends_at",
        "participants.id",
        "participants.participant.id",
        "participants.participant.email",
      ],
    };

    const data = await updateItemInCollection(
      "calendar_events",
      meetingId,
      item,
      query
    );

    return data;
  } catch (error) {
    console.log(error);
    throw error;
  }
}
